/* global System */

export default {
  Lexicon: () => System.import(/* webpackChunkName: "Lexicon" */ './index'),
}
